// extracted by mini-css-extract-plugin
export var closeButton = "_mc-1";
export var closeX = "_mc-3";
export var container = "_mc-0";
export var image = "_mc-2";